import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import '@medprompt/shared/src/common/modals.css';
import './PatientStatusWarningModal.css';

/**
 * Proactive patient status warning popup that appears once per document per session
 * when a document is opened and the patient has a concerning status.
 *
 * Fired by DocumentDetailViewController when status is DEDUCTION_PENDING or INACTIVE.
 */
const PatientStatusWarningModal = ({ status, patientName, onDismiss }) => {
  if (!status || status === 'ACTIVE') return null;

  const getWarningContent = () => {
    switch (status) {
      case 'DEDUCTION_PENDING':
        return {
          title: 'Patient Deregistration in Progress',
          message: 'This patient is in the process of being deregistered from the practice.',
          modalClass: 'modal-deduction-pending',
        };
      case 'INACTIVE':
        return {
          title: 'Patient Deregistered',
          message: 'This patient has been deregistered from the practice.',
          modalClass: 'modal-inactive',
        };
      default:
        return null;
    }
  };

  const content = getWarningContent();
  if (!content) return null;

  return (
    <div className="modal-overlay" onClick={onDismiss}>
      <div
        className={`modal-container patient-status-warning-modal ${content.modalClass} modal-animated`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <div className="patient-status-warning-title">
            <h2>{content.title}</h2>
          </div>
          <button className="close-button" onClick={onDismiss}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="modal-content patient-status-warning-content">
          <div className="warning-icon-container">
            <FontAwesomeIcon 
              icon={faExclamationTriangle} 
              className="warning-icon-large"
            />
          </div>
          <p className="patient-status-warning-message">
            {content.message}
          </p>
          {patientName && (
            <p className="patient-status-patient-name">
              Patient: <strong>{patientName}</strong>
            </p>
          )}
        </div>

        <div className="modal-actions">
          <button className="cancel-button" onClick={onDismiss}>
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
};

export default PatientStatusWarningModal;
